// src/components/Terms.js
import React from "react";
import { useTranslation } from "react-i18next";

const TERMS_VERSION = "2026-02-01";

export default function Terms() {
    const { t } = useTranslation();

    return (
        <div
            style={{
                maxWidth: 900,
                margin: "40px auto",
                padding: "20px",
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#222",
            }}
        >
            <h2 style={{ color: "var(--primary-blue)", textAlign: "center", marginBottom: 10 }}>
                {t('terms.title')}
            </h2>

            <p style={{ textAlign: "center", color: "#666", marginTop: 0 }}>
                {t('terms.appName')} — {t('terms.version')} <strong>{TERMS_VERSION}</strong>
            </p>

            <hr style={{ margin: "18px 0", borderColor: "#eee" }} />

            <h3>{t('terms.sections.object.title')}</h3>
            <p>{t('terms.sections.object.content')}</p>

            <h3>{t('terms.sections.access.title')}</h3>
            <p>{t('terms.sections.access.content1')}</p>
            <p>
                <strong>{t('terms.sections.access.visibilityTitle')}</strong> {t('terms.sections.access.visibilityContent')}
            </p>

            <h3>{t('terms.sections.usage.title')}</h3>
            <p>{t('terms.sections.usage.intro')}</p>
            <ul style={{ paddingLeft: 18 }}>
                {t('terms.sections.usage.rules', { returnObjects: true }).map((rule, i) => (
                    <li key={i}>{rule}</li>
                ))}
            </ul>

            <h3>{t('terms.sections.security.title')}</h3>
            <p>{t('terms.sections.security.content')}</p>

            <h3>{t('terms.sections.data.title')}</h3>
            <p>{t('terms.sections.data.summary')}</p>
            <p>
                <a href="/confidentialite" target="_blank" rel="noopener noreferrer" style={{ color: "var(--primary-blue)", textDecoration: "underline", fontWeight: 600 }}>
                    {t('privacy.title')}
                </a>
            </p>

            <h3>{t('terms.sections.availability.title')}</h3>
            <p>{t('terms.sections.availability.content')}</p>

            <h3>{t('terms.sections.evolution.title')}</h3>
            <p>{t('terms.sections.evolution.content')}</p>

            <h3>{t('terms.sections.contact.title')}</h3>
            <p>
                {t('terms.sections.contact.content')} <strong>contact@swissdiveagenda.ch</strong>
            </p>

            <hr style={{ margin: "18px 0", borderColor: "#eee" }} />

            <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                <button
                    type="button"
                    onClick={() => {
                        // Si la page a été ouverte dans un nouvel onglet, ça ferme
                        // (marche si l'onglet a été ouvert via script / parfois bloqué sinon)
                        window.close();

                        // fallback si le navigateur bloque window.close()
                        setTimeout(() => {
                            window.location.href = "/";
                        }, 150);
                    }}
                    style={{
                        width: "100%",
                        padding: "10px",
                        background: "var(--primary-blue)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: "bold",
                        marginTop: 18,
                    }}
                >
                    {t('common.close')}
                </button>

            </div>
        </div>
    );
}
